import type { AxiosResponse } from 'axios';
import { isServerError } from 'src/hooks/use-axios';
import type { AxiosErrorWithConfig } from 'src/hooks/use-axios';
import type { StrictOmit } from 'src/utils/utility-types';

const type = 'https://problem.prisma-capacity.eu/subscription-required';

type SubscriptionRequiredResponse = {
  type: typeof type;
  status: 402;
  title: 'Subscription Required';
  detail: string;
  requiredFeatures: string[];
};

type SubscriptionRequired = StrictOmit<AxiosErrorWithConfig, 'response'> & {
  response: AxiosResponse<SubscriptionRequiredResponse>;
};

export function isSubscriptionRequired(
  err: unknown
): err is SubscriptionRequired {
  return (
    isServerError(err, null) &&
    !!err.response.data &&
    (err.response.data as any).type === type
  );
}
